class MediaCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this.querySelector('[carousel-list]');
    this.elements = this.querySelectorAll('[carousel-list] > *');
    this.currentIndex = 0;

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.currentIndex = entry.target.index;
            document.dispatchEvent(new CustomEvent('custom:carousel:index', { detail: entry.target.index }));
          }
        });
      },
      {
        threshold: 0.51,
      },
    );

    this.elements.forEach((element, index) => {
      element.index = index;
      this.observer.observe(element);
      element.addEventListener('click', (ev) => {
        if (window.innerWidth <= 767) {
          this.element.toggleAttribute('data-expanded');
          document.querySelector('product-info').classList.toggle('hidden');
          this.querySelector('svg').classList.toggle('hidden');
          this.querySelectorAll('img[loading]').forEach((el) => el.removeAttribute('loading'));
          if (!this.element.hasAttribute('data-expanded')) {
            this.element.scrollLeft = ev.target.parentNode.index * this.element.getBoundingClientRect().width;
            document.dispatchEvent(new CustomEvent('custom:carousel:index', { detail: ev.target.parentNode.index }));
          } else {
            element.scrollIntoView();
          }
        }
      });
    });

    if (this.dataset.desktopTouch) {
      this.initDesktopTouch();
    }
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  initDesktopTouch() {
    if (window.innerWidth <= 767) return;
    this.elements.forEach((element) => element.classList.add('pointer-events-none', 'select-none'));

    let isDrag = false;
    let timeout;
    const dragStart = (ev) => {
      isDrag = true;
      this.element.classList.add('snap-none');
      if (timeout) clearTimeout(timeout);
    };
    const dragEnd = () => {
      if (!isDrag) return;
      isDrag = false;
      this.elements[this.currentIndex].scrollIntoView({ behavior: 'smooth' });
      timeout = setTimeout(() => {
        this.element.classList.remove('snap-none');
      }, 700);
    };
    const drag = (event) => {
      if (!isDrag) return;
      this.element.scrollLeft -= event.movementX * 1.6;
    };

    this.element.addEventListener('pointerdown', dragStart);
    this.element.addEventListener('pointerup', dragEnd);
    this.element.addEventListener('pointerleave', dragEnd);
    this.element.addEventListener('pointermove', drag);
  }
}

customElements.define('media-carousel', MediaCarousel);
